import { requestGet } from '@/common/request';

export interface goodsStrategyListParams {
  channelId: string;
  channelType: number;
  jobId?: number;
  jobName?: string;
  pageNo: number;
  pageSize: number;
}

export interface goodsStrategyListRes {
  ret: string;
  msg: string;
  data:
    | {
        pageNo: number;
        pageSize: number;
        totalCount: number;
        data:
          | Array<{
              jobId: string;
              jobName: string;
              jobDescription: string;
              createBy: string;
              createdByCN: string;
              wareCount: number;
              type: number;
              ruleGroups: Array<{ ruleGroupId: string; ruleGroupName: string }> | [];
            }>
          | [];
      }
    | undefined;
}

//营销阵地/日常活动 - 商品策略列表
export async function goodsStrategyList(params: goodsStrategyListParams): Promise<goodsStrategyListRes> {
  return await requestGet('/ware/goodsStrategyList', params);
}
